import { render, staticRenderFns } from "./photo-template.vue?vue&type=template&id=2d201e21&scoped=true&"
import script from "./photo-template.vue?vue&type=script&lang=js&"
export * from "./photo-template.vue?vue&type=script&lang=js&"
import style0 from "./photo-template.vue?vue&type=style&index=0&id=2d201e21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d201e21",
  null
  
)

export default component.exports